module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-500.woff2?61e2d96d01a7eba5ea3ec1bad7e736a8";